import Api from "@/api";
const route = "client-types";

const index = async (param) => {
  const result = await Api.query(`v1/${route}`, param);
  return result.data;
};

export default {
  index
};
